const homeFunc = (gsap) => {
	
	// Hero
	const heroContent = document.querySelector('.home-hero .content');
	const heroIlloPhone = document.querySelectorAll('.hero-illo img.phone');
	const heroIllo = document.querySelectorAll('.hero-illo img:not(.phone)');
	const heroTL = gsap.timeline();
	
	heroTL.set(heroContent, {autoAlpha: 0, y: 30})
				.set([heroIllo, heroIlloPhone], {autoAlpha: 0, y: 80})
				.to(heroContent, {autoAlpha: 1, y: 0, duration: 0.6})
				.to(heroIlloPhone, {autoAlpha: 1, y: 0, duration: 0.6})
				.to(heroIllo, {duration: 0.6, stagger: 0.2, autoAlpha: 1, y: 0}, "-=0.05");
		
}

export {
	homeFunc
};
